import { Text } from '@chakra-ui/react';
import { FormattedDate } from 'react-intl';

interface FormattedDateTimeProps {
  date: Date;
  color?: string;
  textStyle?: 'sm' | 'md' | 'lg';
}

export default function FormattedDateTime(
  props: Readonly<FormattedDateTimeProps> & Readonly<Intl.DateTimeFormatOptions>,
) {
  const { date, color = 'neutral.black', textStyle = 'sm' } = props;
  return (
    <FormattedDate value={date} {...props}>
      {(date) => (
        <Text color={color} textStyle={textStyle}>
          {date}
        </Text>
      )}
    </FormattedDate>
  );
}
